import { Reducer } from 'redux';

import { ValidEmailsActionTypes, ValidEmailsState } from './types';

const defaultState = {
    loadingEmails: false,
    loadedEmails: false,
    emails: [],
};

const reducer: Reducer<ValidEmailsState> = (state: ValidEmailsState = defaultState, action): ValidEmailsState => {
    const { payload, type } = action;

    switch (type) {
        case ValidEmailsActionTypes.VALIDEMAILS_FETCH_START:
        case ValidEmailsActionTypes.VALIDEMAILS_ADD:
            return {
                ...state,
                loadingEmails: true,
                loadedEmails: false,
            };
        case ValidEmailsActionTypes.VALIDEMAILS_ADD_ERROR:
        case ValidEmailsActionTypes.VALIDEMAILS_FETCH_ERROR:
            return {
                ...state,
                loadingEmails: false,
            };
        case ValidEmailsActionTypes.VALIDEMAILS_ADD_SUCCESS:
            return {
                ...state,
                loadingEmails: false,
                loadedEmails: true,
                emails: [...state.emails, payload.emails],
            };
        case ValidEmailsActionTypes.VALIDEMAILS_FETCH_SUCCESS:
            return {
                loadingEmails: false,
                loadedEmails: true,
                emails: payload.emails,
            };
        case ValidEmailsActionTypes.VALIDEMAILS_DELETE_SUCCESS:
            return {
                ...state,
                emails: payload.emails,
            };
        case ValidEmailsActionTypes.VALIDEMAILS_SINGLE_VIEW_DELETE:
        case ValidEmailsActionTypes.VALIDEMAILS_SINGLE_VIEW:
            return {
                ...state,
                singleViewEmail: payload.email,
            };
        default:
            return state;
    }
};

export { reducer as validEmails };

export default reducer;
